import { MenuItemProps } from "@mc/ui-v4";

export const NAVBAR_ITEMS: MenuItemProps[] = [
  { label: "Domů", key: "home", link: { to: "/soudni-spory" } }, // remember to pass the key prop
  {
    label: "Seznam soudních sporů",
    key: "seznam-sporu",
    link: { to: "/soudni-spory/seznam" },
  }, // which is required
];
